import { render, staticRenderFns } from "./TheNavigationDesktop.vue?vue&type=template&id=e2973eee&scoped=true&"
import script from "./TheNavigationDesktop.vue?vue&type=script&lang=ts&"
export * from "./TheNavigationDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./TheNavigationDesktop.vue?vue&type=style&index=0&id=e2973eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2973eee",
  null
  
)

export default component.exports